module.exports = __webpack_public_path__ + "img/zhwl2.f3a24267.png";